const IS_LOADING = "lists/notification_templates/IS_LOADING";
const IS_PARTIAL_LOADING = "lists/notification_templates/IS_PARTIAL_LOADING";
const IS_ERROR = "lists/notification_templates/IS_ERROR";
const DATA = "lists/notification_templates/DATA";
const NOTIFICATION = "lists/notification_templates/NOTIFICATION";
const EDIT = "lists/notification_templates/EDIT";

export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, DATA, NOTIFICATION, EDIT };
